/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ suffix: NonNullable<unknown> }} Explorer_Nav_Move_Locked_ErrorInputs */

const en_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot move locked item${i?.suffix}`)
};

const fr_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible de deplacer l'element verrouille${i?.suffix}`)
};

const de_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gesperrtes Objekt${i?.suffix} kann nicht verschoben werden`)
};

const it_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile spostare l'oggetto bloccato${i?.suffix}`)
};

const ru_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Невозможно переместить заблокированный элемент${i?.suffix}`)
};

const es_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede mover el elemento bloqueado${i?.suffix}`)
};

const zh_cn2_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法移动锁定物品${i?.suffix}`)
};

const ja_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ロックされたアイテムを移動できません${i?.suffix}`)
};

const hi_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`लॉक किए गए आइटम${i?.suffix} को स्थानांतरित नहीं किया जा सकता`)
};

const pt_pt2_explorer_nav_move_locked_error = /** @type {(inputs: Explorer_Nav_Move_Locked_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não é possível mover o item bloqueado${i?.suffix}`)
};

/**
* | output |
* | --- |
* | "Cannot move locked item{suffix}" |
*
* @param {Explorer_Nav_Move_Locked_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_move_locked_error = /** @type {((inputs: Explorer_Nav_Move_Locked_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Move_Locked_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_move_locked_error(inputs)
	if (locale === "de") return de_explorer_nav_move_locked_error(inputs)
	if (locale === "it") return it_explorer_nav_move_locked_error(inputs)
	if (locale === "ru") return ru_explorer_nav_move_locked_error(inputs)
	if (locale === "es") return es_explorer_nav_move_locked_error(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_move_locked_error(inputs)
	if (locale === "ja") return ja_explorer_nav_move_locked_error(inputs)
	if (locale === "hi") return hi_explorer_nav_move_locked_error(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_move_locked_error(inputs)
	return en_explorer_nav_move_locked_error(inputs)
});